import dayjs from "dayjs";
import { formatTime12h } from "@/data/staticMethod";
import { resetTimeBilledDays } from "@/utils/formatDuration";

// Reset-time partners bill per rental day (e.g. 9 AM to 9 AM), so a 24h trip can cost 2 days.
export const getRentalDayBilling = (startAt, endAt, rent) => {
  if (rent?.calculationType !== "reset_time" || !rent?.rate?.resetTime) return null;
  const start = dayjs(startAt);
  const end = dayjs(endAt);
  const days = resetTimeBilledDays(start, end, rent.rate);
  if (!days || days <= Math.ceil(end.diff(start, "hour", true) / 24)) return null;
  const total = Number(rent.total);
  const perDay = [rent.rate.wdDaily, rent.rate.weDaily].find((r) => r && Math.abs(r * days - total) < 1) || null;
  return {
    days,
    perDay,
    resetAt: formatTime12h(rent.rate.resetTime).replace(":00 ", " "),
  };
};

export const RentalDayNote = ({ billing, className = "" }) => {
  if (!billing) return null;
  return (
    <p className={`flex gap-2 rounded-lg bg-gray-50 border border-gray-200 px-3 py-2 text-xs leading-snug text-gray-700 ${className}`}>
      <svg viewBox="0 0 24 24" className="w-4 h-4 shrink-0 mt-px text-gray-500" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true"><circle cx="12" cy="12" r="10" /><path d="M12 16v-4M12 8h.01" strokeLinecap="round" /></svg>
      <span>
        At this location the rental day ends at {billing.resetAt}. So your trip is billed as {billing.days} rental days.
      </span>
    </p>
  );
};
